import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all cost responsibilities
export const getCostResponsibility = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/cost-responsibility`);
    return response.data;
  } catch (error) {
    console.error("Error fetching cost responsibilities:", error.response?.data || error);
    throw error;
  }
};

// GET a single cost responsibility
export const getCostResponsibilityById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/cost-responsibility/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching cost responsibility:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new cost responsibility
export const createCostResponsibility = async (costCentreData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/cost-responsibility`, costCentreData);
    return response.data;
  } catch (error) {
    console.error("Error creating cost responsibility:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing cost responsibility
export const updateCostResponsibility = async (id, costCentreData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/cost-responsibility/${id}`, costCentreData);
    return response.data;
  } catch (error) {
    console.error("Error updating cost responsibility:", error.response?.data || error);
    throw error;
  }
};

// DELETE a cost responsibility
export const deleteCostResponsibility = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/cost-responsibility/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting cost responsibility:", error.response?.data || error);
    throw error;
  }
};
